import styled from 'styled-components';
import { TypographyStyles, fonts, maxWidthPartial, media, spacing } from '@storefront/lib-global/stylings';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Container = styled.div`
  ${maxWidthPartial({ withPaddingXL: true })}
  align-self: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
  margin-bottom: ${spacing.M};

  @media ${media.greaterThan('lg')} {
    flex-direction: row;
    gap: ${spacing.XXL};
  }
`;
export const ProductFilterContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  @media ${media.greaterThan('lg')} {
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0;
    width: auto;
  }
`;
export const MobileContainer = styled.div`
  display: grid;
  gap: ${spacing.XXXS};
  grid-template-columns: repeat(2, minmax(50px, 160px));
  height: 70px;
  margin-bottom: ${spacing.XL};
  max-width: 999px;
  overflow: hidden;
  width: 100%;
  @media screen and (min-width: 376px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const CategoryName = styled.h1`
  ${fonts.Oswald}
  ${TypographyStyles.Headings.H3}
  margin: 0;
  padding: 24px 24px 12px;
  text-transform: uppercase;
`;

export const TopContainer = styled.div`
  align-items: center;
  display: flex;
  margin: auto;
  max-width: 1440px;
  padding: 20px ${spacing.S};
  width: 100%;

  @media ${media.greaterThan('lg')} {
    height: 111px;
    padding: ${spacing.XS} ${spacing.S} 45px;
  }
  @media ${media.greaterThan('xl')} {
    padding: ${spacing.XS} 70px 45px;
  }
`;
